import { FormLabel, FormSelect, InputGroup } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";


const SelectOptionsEditor = (props: IFieldEditor) => {
  const [options, setOptions] = useState<Array<string>>([]);

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    props.onValueChange(props.property.Id, value);
  }

  useEffect(() => {
    if (props.property.DefaultValue) {
      const opts = props.property.DefaultValue.split('|');

      if (opts.length > 0) {
        setOptions(opts);
      }
    }
  }, [props.property.DefaultValue]);

  return(
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      <InputGroup>
        <InputGroupText>
          <FontAwesomeIcon icon={faList} />
        </InputGroupText>
        <FormSelect
          title={`options for ${props.property.DisplayLabel}`}
          value={props.property.PublishedValue ?? options?.[0] ?? ""}
          onChange={handleSelect}>

          <option value="" disabled>Select...</option>

          {options.length > 0 && options.map(opt => (
            <option key={opt} value={opt.toLowerCase()}>{opt}</option>
          ))}
        </FormSelect>
      </InputGroup>
    </>
  );
}

export default SelectOptionsEditor;